/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  conversationActive as conversationActiveAction,
  clearConversationActive,
} from 'Redux/modules/webChat/conversationActive/actions';
import toast, { Toaster, useToaster, useToasterStore } from 'react-hot-toast';
import {
  getNotifications,
  getBadges,
  registerDevice,
  minusBadges,
  readNotification,
} from 'Redux/modules/notification/actions';
import { addModal, clearModal } from 'Redux/modules/modal/actions';
import { useHistory } from 'react-router';
import { Icon } from 'semantic-ui-react';
import { denormalizeConversationsByActiveClinic } from 'Selectors/webChat/consults';
import { fetchSettings, generateIncludeParams } from 'Helpers/utils';
import { updateEntities } from 'Redux/modules/entities/actions';
import { WEBCHAT } from 'Constants/normalize-module';
import {
  bubblesRemove,
  getMessagesBackwardByTime,
  unregisterNotificationTokenConsult,
  registerNotificationTokenConsult,
  messageMarkAsRead,
  closeAllContextMenu,
  conversationRetrieve,
} from 'Redux/modules/webChat/actions';
import { hideContextMenu } from 'Redux/modules/contextMenu/actions';
import { DEFAULT_GET_NOTI_PARAMS } from 'Containers/Notification/constants';
import { APPOINTMENT, LAB_REPORT, TELECONSULT } from 'Constants/service-types';
import { POOL_REQUESTS_TAB_ID } from 'Constants/consults';
import useActiveClinicTab from 'Containers/Teleconsult/hooks/useActiveClinicTab';
import { findClinicIdFromClinicsMapping } from 'Helpers/consult-utils';

import { FirebaseContext } from '../../../fcm/firebase';
import { CONVERSATION_MODEL_RESPONSE, MESSAGES_COUNT_PER_PAGE } from '../../../constants/webchat';
import { selectConsultPending } from '../../../redux/modules/webChat/actions';

import styles from './Notification.less';

const CONVERSATION_INCLUDES_PARAM = {
  include: generateIncludeParams(CONVERSATION_MODEL_RESPONSE),
};

const NotifComponent = ({ data, onClick, onClose, ...rest }) => (
  <div {...rest} className={styles.containerWrapper}>
    <div className={styles.container} onClick={onClick}>
      {data?.title && <div className={styles.title}>{data?.title}</div>}
      <div className={styles.body}>{data?.message}</div>
    </div>
    <Icon name="close" onClick={onClose} style={{ cursor: 'pointer' }} />
  </div>
);

export const displayPushNotification = (messageData, options) => {
  toast(
    t => (
      <NotifComponent
        onMouseEnter={options.startPause}
        onMouseLeave={options.endPause}
        data={messageData}
        onClick={() => {
          options.onClick();
          toast.dismiss(t.id);
        }}
        onClose={() => toast.dismiss(t.id)}
      />
    ),
    {
      style: {
        padding: '0px',
        borderRadius: '4px',
        overflow: 'hidden',
      },
      duration: 50000,
      position: 'bottom-left',
      icon: (
        <div className={styles.infoIcon}>
          <Icon name="info" />
        </div>
      ),
    },
  );
};

const LIMIT_TOAST = 5;

const Notification = () => {
  const { toasts } = useToasterStore();
  const { handlers } = useToaster();
  const { startPause, endPause } = handlers;
  const { webGetToken, showMessage } = useContext(FirebaseContext);
  const dispatch = useDispatch();
  const history = useHistory();
  const { setActiveClinicTab } = useActiveClinicTab();
  const conversationActiveId = useSelector(state => state.webChat.conversationActive);
  const { toastPosition } = useSelector(state => state.ui);
  const conversations = useSelector(state => denormalizeConversationsByActiveClinic(state));
  const doctorData = useSelector(state => state.webChat.doctor);
  const bubbleIds = useSelector(state => state.webChat.commons.bubbles);

  const jumpToPoolRequestTab = () => {
    dispatch(clearModal());
    dispatch(hideContextMenu());
    dispatch(closeAllContextMenu());
    dispatch(clearConversationActive());
    setActiveClinicTab(POOL_REQUESTS_TAB_ID, false);
  };

  useEffect(() => {
    toasts
      .filter(tt => tt.visible)
      .filter((_, i) => i >= LIMIT_TOAST)
      .forEach(tt => toast.dismiss(tt.id));
  }, [toasts]);

  useEffect(() => {
    async function initFirebase() {
      const globSettings = fetchSettings() || {};
      const {
        FIREBASE_API_KEY,
        FIREBASE_APP_ID,
        FIREBASE_MEASUREMENT_ID,
        FIREBASE_PROJECT_ID,
        FIREBASE_SENDER_ID,
        FIREBASE_VAPID,
      } = globSettings;
      const firebaseConfig = {
        apiKey: FIREBASE_API_KEY,
        authDomain: `${FIREBASE_PROJECT_ID}.firebaseapp.com`,
        databaseURL: `https://${FIREBASE_PROJECT_ID}.firebaseio.com`,
        projectId: FIREBASE_PROJECT_ID,
        storageBucket: `${FIREBASE_PROJECT_ID}.appspot.com`,
        messagingSenderId: FIREBASE_SENDER_ID,
        appId: FIREBASE_APP_ID,
        measurementId: FIREBASE_MEASUREMENT_ID,
      };
      const firebaseToken = await webGetToken(firebaseConfig, FIREBASE_VAPID);
      const firebaseTokenOld = localStorage.getItem('firebase-token');

      if (firebaseToken && firebaseToken !== firebaseTokenOld) {
        if (firebaseTokenOld) dispatch(unregisterNotificationTokenConsult(firebaseTokenOld));
        dispatch(registerNotificationTokenConsult(firebaseToken));
        dispatch(
          registerDevice({
            token: firebaseToken,
            platform: 'web',
            tokenType: 'fcm',
          }),
        );
        localStorage.setItem('firebase-token', firebaseToken);
      }
    }
    initFirebase();
  }, [dispatch, webGetToken]);

  useEffect(() => {
    // init handle FCM for 2 cases: teleconsult noti and not-teleconsult noti
    async function initHandleMessage() {
      showMessage(async messageData => {
        try {
          console.log('🚀 ~ FCM received. ', messageData);
          if (!messageData.data) return;

          if (messageData.data?.service === TELECONSULT) {
            // full noti object
            const notiObj = JSON.parse(messageData.data?.content);
            const notiConversationId = notiObj.metadata?.conversation_id;

            const pushNotiData = {
              title: messageData.data?.title,
              message: messageData.data?.body,
            };

            // Find in current clinic list
            let conversation = conversations.find(
              item =>
                item.id === notiConversationId ||
                item?.latestConsult?.doctorConversationId === notiConversationId,
            );

            // display push noti if not users are not focusing in noti's conversation
            if (
              !bubbleIds
                .filter(e => !e.isMinimum)
                .map(e => e.id)
                .includes(conversation?.id) &&
              conversationActiveId !== conversation?.id &&
              doctorData?.data?.userUuid !== notiObj.user
            ) {
              displayPushNotification(pushNotiData, {
                startPause,
                endPause,
                onClick: async () => {
                  if (notiObj.type === 'consult_service') {
                    jumpToPoolRequestTab();
                  } else {
                    // If not found in current clinic list, get from API
                    // - If type is consult-group (chat between doctor and patient), set conversation to API response
                    // - If type is consult-group-private (chat between doctor and doctor), call API to find its conversation between doctor and patient to set conversation
                    if (!conversation) {
                      const firstCallRes = await dispatch(
                        conversationRetrieve(notiConversationId, CONVERSATION_INCLUDES_PARAM),
                      );

                      if (firstCallRes?.data?.type === 'consult-group') {
                        conversation = firstCallRes?.data;
                      } else {
                        const secondCallRes = await dispatch(
                          conversationRetrieve(
                            firstCallRes?.data?.latestConsult?.conversationId,
                            CONVERSATION_INCLUDES_PARAM,
                          ),
                        );

                        conversation = secondCallRes?.data;
                      }
                    }

                    const conversationClinicId = findClinicIdFromClinicsMapping(
                      conversation?.latestConsult?.clinics || [],
                      doctorData?.data?.id,
                    );

                    // get messages of conversation
                    if (conversation?.id) {
                      dispatch(
                        getMessagesBackwardByTime({
                          conversationId: conversation?.id,
                          count: MESSAGES_COUNT_PER_PAGE,
                          timestamp: Date.now(),
                        }),
                      );
                    }

                    // get private messages
                    if (conversation?.latestConsult?.doctorConversationId) {
                      dispatch(
                        getMessagesBackwardByTime({
                          conversationId: conversation?.latestConsult?.doctorConversationId,
                          count: MESSAGES_COUNT_PER_PAGE,
                          timestamp: Date.now(),
                        }),
                      );
                    }

                    dispatch(
                      messageMarkAsRead({
                        action: 'read',
                        user: doctorData?.data?.userUuid,
                        metadata: {
                          consultId: notiObj.metadata?.consult_id,
                          conversationId: conversation?.id,
                          consultType: notiObj.metadata?.consult_type,
                        },
                      }),
                    );

                    dispatch(
                      updateEntities(WEBCHAT, 'conversation', conversation?.id, {
                        participant: {
                          unreadCount: 0,
                        },
                      }),
                    );
                    dispatch(conversationActiveAction(conversation?.id, true));
                    setActiveClinicTab(conversationClinicId, false);

                    dispatch(bubblesRemove(conversation?.id));
                    dispatch(selectConsultPending(-1));
                  }
                },
              });
            }
          } else {
            if (!messageData.data.regular) return;

            // full noti object
            const notiObj = JSON.parse(messageData.data.regular);

            // not handle for teleconsult type (handled in case above)
            if (notiObj.service === TELECONSULT) return;

            // update noti list and badges number
            dispatch(getNotifications(DEFAULT_GET_NOTI_PARAMS));
            dispatch(getBadges());

            const pushNotiData = {
              title: messageData.notification?.title || notiObj.title || '',
              message: messageData.notification?.body || notiObj?.body || undefined,
            };

            displayPushNotification(pushNotiData, {
              startPause,
              endPause,
              onClick: () => {
                dispatch(readNotification(notiObj.id));
                dispatch(minusBadges());

                if (notiObj.service === APPOINTMENT) {
                  history.push('/appointments');
                } else if (notiObj.service === LAB_REPORT) {
                  history.push('/lab-results');
                }

                const prescriptionId = notiObj.data?.prescription_id;
                if (prescriptionId) {
                  dispatch(
                    addModal({
                      type: 'prescription',
                      id: 2,
                      data: {
                        prescriptionId,
                      },
                    }),
                  );
                }
              },
            });
          }
        } catch (e) {
          console.error(e);
        }
      });
    }

    initHandleMessage();
  }, [conversationActiveId, bubbleIds, doctorData, conversations, dispatch]);

  return (
    <Toaster
      containerStyle={{
        zIndex: 900000,
        top: 54,
      }}
      toastOptions={{
        style: {
          zIndex: 2,
        },
      }}
      position={toastPosition}
    />
  );
};

export default Notification;
